// src/features/support/api/support.api.ts
import { apiClient } from '../../../app/api/apiClient';

/**
 * The exact response shape for GET /api/support/tickets hasn't been
 * shared. Field names below follow the same snake_case convention as
 * the rest of the backend's DTOs (see customers.api.ts); adjust here —
 * and only here — once the real contract is confirmed.
 */
export interface SupportTicketDTO {
  id: number | string;
  title?: string;
  subject?: string;
  category?: string;
  status?: string;
  created_at?: string;
}

interface SupportTicketsResponse {
  tickets: SupportTicketDTO[];
}

export async function fetchSupportTickets(): Promise<SupportTicketsResponse> {
  const response = await apiClient.get<SupportTicketsResponse>('/api/support/tickets');

  return response.data;
}
